/* Shared helpers and constants for FinancePage. */

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    const today = new Date();
    const isToday = d.toDateString() === today.toDateString();
    if (isToday) return `Hoy, ${d.toLocaleTimeString("es-UY", { hour: "2-digit", minute: "2-digit" })}`;
    const yesterday = new Date(today); yesterday.setDate(today.getDate() - 1);
    if (d.toDateString() === yesterday.toDateString())
      return `Ayer, ${d.toLocaleTimeString("es-UY", { hour: "2-digit", minute: "2-digit" })}`;
    return d.toLocaleDateString("es-UY", { day: "numeric", month: "short", year: "numeric" });
  } catch { return iso; }
}

export function fmtAmt(amount, currency, short = false) {
  if (!amount && amount !== 0) return "—";
  const sym = currency === "USD" ? "U$S" : currency === "UYU" ? "$" : (currency || "$");
  const num = Number(amount);
  if (short && num >= 1000000) return `${sym} ${(num / 1000000).toFixed(1)}M`;
  if (short && num >= 1000) return `${sym} ${(num / 1000).toFixed(1)}K`;
  return `${sym} ${num.toLocaleString("es-UY", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
}

export const CATEGORY_LABELS = {
  subscription: "Suscripción", domain: "Dominio", hosting: "Hosting",
  ads: "Publicidad", tools: "Herramientas", salary: "Sueldos",
  general: "General", other: "Otro",
};

export const CURRENCIES = ["UYU", "USD", "EUR", "ARS"];

export function ChartTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-2xl px-4 py-3 text-sm" style={{ background: "#1a1a1a", border: "1px solid rgba(255,255,255,0.1)" }}>
      <p className="text-white font-bold mb-1.5">{label}</p>
      {payload.map(p => (
        <p key={p.dataKey} className="text-xs" style={{ color: p.fill }}>
          {p.dataKey === "income" ? "Ingresos" : "Egresos"}: {fmtAmt(p.value, "")}
        </p>
      ))}
    </div>
  );
}
